import React, { useState, useEffect } from 'react'
import { Layers, GitCompareArrows, Activity, BarChart3, BarChart2 } from 'lucide-react'

export const SUB_TABS = [ 'Combined OI', 'Combined Volume', 'Top OI', 'Top Volume', 'Top Chng OI', 'Vol-OI', 'Vol-OI-Chng' ] as const

export const SubTabSwitcher = ( { activeSubTab, onTabChange }: { activeSubTab: string, onTabChange: ( tab: string ) => void } ) =>
{
    const [ visualTab, setVisualTab ] = useState( activeSubTab )

    useEffect( () =>
    {
        setVisualTab( activeSubTab )
    }, [ activeSubTab ] )

    const handleTabClick = ( tab: string ) =>
    {
        if ( tab === visualTab ) return

        setVisualTab( tab )
        onTabChange( tab )
    }

    return (
        <div className="flex flex-nowrap items-center max-w-full overflow-x-auto overflow-y-hidden no-scrollbar bg-slate-100/80 dark:bg-slate-800/80 p-1.5 rounded-2xl ring-1 ring-inset ring-slate-200/50 dark:ring-slate-700/50">
            { SUB_TABS.map( ( tab ) =>
            {
                const isActive = visualTab === tab
                const Icon = tab.includes( 'Combined' ) ? Layers
                    : tab.includes( 'Chng' ) ? GitCompareArrows
                        : tab.includes( 'Vol-OI-Chng' ) ? GitCompareArrows
                            : tab.includes( 'Vol-OI' ) ? Activity
                                : tab.includes( 'Volume' ) ? BarChart3
                                    : BarChart2
                return (
                    <button
                        key={ tab }
                        onClick={ () => handleTabClick( tab ) }
                        className={ `flex shrink-0 items-center justify-center gap-1 xl:gap-2 h-8 md:h-8 xl:h-9 px-2 md:px-2.5 xl:px-4 rounded-xl text-[10px] md:text-[11px] xl:text-sm font-semibold tracking-tight transition-all duration-300 select-none whitespace-nowrap outline-none
                            ${isActive
                                ? 'bg-white dark:bg-slate-700 text-indigo-600 dark:text-indigo-400 shadow-[0_2px_8px_-2px_rgba(0,0,0,0.1)] ring-1 ring-slate-200/50 dark:ring-slate-600'
                                : 'text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:hover:text-slate-200 hover:bg-slate-200/50 dark:hover:bg-slate-700/50 border-transparent'
                            }` }
                    >
                        <Icon strokeWidth={ isActive ? 2.5 : 2 } className={ `w-[14px] h-[14px] xl:w-[16px] xl:h-[16px] shrink-0 transition-all duration-300 ${isActive ? 'text-indigo-600 dark:text-indigo-400 scale-[1.05]' : 'opacity-70 scale-100'}` } />
                        <span>{ tab }</span>
                    </button>
                )
            } ) }
        </div>
    )
}
